import React, { Fragment, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { profileVendor } from "../../actions/profile";
import Countries from "../../components/Countries";
const BecomeVendor = (props) => {
  const [values, setValues] = useState({
    storeName: "",
    storePhone: "",
    storeLogo: "",
    storeBanner: "",
    storeAddress: "",
    storeCountry: "",
    storeRegion: "",
    storeCity: "",
    storePostcode: "",
    storeShoppingPolicy: "",
    storeReturnPolicy: "",
    storeMetaKeywords: "",
    storeMetaDescription: "",
    storeSlug: "",
    storeFacebook: "",
    storeTwitter: "",
    storeInstagram: "",
    storePinterest: "",
    storeWebsite: "",
    storeWhatsapp: "",
    sellerBankDetail: "",
    taxIdentificationNumber: "",
    paypalEmail: "",
    sellerInfoTab: "show",
    sellerPaymentTab: "hide",
    sellerPaymentTabIcon: "",
    formClass: "show",
    successMessge: "hide",
  });
  /*   constructor(props) {
    super(props);
    values = {
      storeName: "",
      storePhone: "",
      storeLogo: "",
      storeBanner: "",
      storeAddress: "",
      storeCountry: "",
      storeRegion: "",
      storeCity: "",
      storePostcode: "",
      storeShoppingPolicy: "",
      storeReturnPolicy: "",
      storeMetaKeywords: "",
      storeMetaDescription: "",
      storeSlug: "",
      storeFacebook: "",
      storeTwitter: "",
      storeInstagram: "",
      storePinterest: "",
      storeWebsite: "",
      storeWhatsapp: "",
      sellerBankDetail: "",
      taxIdentificationNumber: "",
      paypalEmail: "",
      sellerInfoTab: "show",
      sellerPaymentTab: "hide",
      sellerPaymentTabIcon: "",
      formClass: "show",
      successMessge: "hide",
    };
  } */
  const profileVendor = async () => {
    if (values.storeName !== "") {
      if (values.sellerInfoTab === "show") {
        setValues({
          ...values,
          sellerPaymentTab: "show",
          sellerInfoTab: "disabled",
          sellerPaymentTabIcon: "active",
        });
      }

      if (
        values.sellerPaymentTab === "show" &&
        values.sellerInfoTab !== "show"
      ) {
        const {
          userId,
          storeName,
          storePhone,
          storeLogo,
          storeBanner,
          storeAddress,
          storeCountry,
          storeRegion,
          storeCity,
          storePostcode,
          storeShoppingPolicy,
          storeReturnPolicy,
          storeMetaKeywords,
          storeMetaDescription,
          storeSlug,
          storeFacebook,
          storeTwitter,
          storeInstagram,
          storePinterest,
          storeWebsite,
          storeWhatsapp,
          sellerBankDetail,
          taxIdentificationNumber,
          paypalEmail,
        } = values;

        const data = {
          userId,
          storeName,
          storePhone,
          storeLogo,
          storeBanner,
          storeAddress,
          storeCountry,
          storeRegion,
          storeCity,
          storePostcode,
          storeShoppingPolicy,
          storeReturnPolicy,
          storeMetaKeywords,
          storeMetaDescription,
          storeSlug,
          storeFacebook,
          storeTwitter,
          storeInstagram,
          storePinterest,
          storeWebsite,
          storeWhatsapp,
          sellerBankDetail,
          taxIdentificationNumber,
          paypalEmail,
        };

        const res = await props.profileVendor(data);

        if (res.status === 200) {
          toast(`Request Successfully Submitted`, { containerId: "B" });
          setValues({ ...values, successMessge: "show", formClass: "hide" });
        }
      }
    } else {
      toast.error(`Please Enter the Store Name`, { containerId: "B" });
    }
  };

  const { formClass, successMessge } = values;
  const { user } = props._auth;
  return (
    <Fragment>
      <ToastContainer
        enableMultiContainer
        containerId={"B"}
        position={toast.POSITION.TOP_RIGHT}
      />
      <div id="account-account" className="container wrapper-90 max-1600">
        <BreadCrumb title={`Become a Seller`} />
        <div className="row">
          <div id="pts-content" className={`col-sm-12 ${successMessge}`}>
            <div className={`text-center`}>
              Your request in under review . you can start selling after admin
              approval
            </div>
          </div>
          <div id="pts-content" className={`col-sm-12 ${formClass}`}>
            {user && user.becomeVendor === true ? (
              <div className={`text-center `}>
                Your request in under review . you can start selling after admin
                approval
              </div>
            ) : (
              <div className={`m-md-5 form-wizard ${formClass}`}>
                <div className="container-fluid myacc-body container-wizard">
                  <h2 className="heading-wizard">Sign up to Become Seller</h2>
                  <form method="POST" id="signup-form" className="signup-form">
                    <fieldset>
                      <div className="fieldset-content">
                        <div className="payment-inputs-container">
                          <div className="payment-month-cvc">
                            <label
                              htmlFor="store-name"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Store Name
                              </span>
                              <input
                                type="text"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storeName: e.target.value,
                                    userId: user && user._id,
                                  })
                                }
                              />
                            </label>
                            <input
                              type="hidden"
                              name="userId"
                              defaultValue={user && user._id}
                            />
                            <label
                              htmlFor="store-phone"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Store Phone
                              </span>
                              <input
                                type="text"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storePhone: e.target.value,
                                  })
                                }
                              />
                            </label>
                          </div>
                          <div className="payment-month-cvc">
                            <label
                              htmlFor="store-logo"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Store Logo
                              </span>
                              <div className="form-file">
                                <input
                                  type="file"
                                  name="your_logo"
                                  id="your_logo"
                                  className="custom-file-input"
                                  onChange={(e) =>
                                    setValues({
                                      ...values,
                                      storeLogo: e.target.value,
                                    })
                                  }
                                />
                                <span id="val" />
                                <span id="button">Select File</span>
                              </div>
                            </label>
                            <label
                              htmlFor="store-banner"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Store Banner
                              </span>
                              <div className="form-file">
                                <input
                                  type="file"
                                  name="your_banner"
                                  id="your_banner"
                                  className="custom-file-input"
                                  onChange={(e) =>
                                    setValues({
                                      ...values,
                                      storeBanner: e.target.value,
                                    })
                                  }
                                />
                                <span id="val1" />
                                <span id="button1">Select File</span>
                              </div>
                            </label>
                          </div>
                          <label
                            htmlFor="store-address"
                            className="payment-input-field"
                          >
                            <span className="payment-inp-placeholder payment-inp-placeholder1">
                              Store Address
                            </span>
                            <input
                              type="text"
                              className="payment-input payment-input1"
                              onChange={(e) =>
                                setValues({
                                  ...values,
                                  storeAddress: e.target.value,
                                })
                              }
                            />
                          </label>
                          <div className="payment-month-cvc">
                            <div className="checkout-inps">
                              <span className="selectContry-hint">
                                Select Contry
                              </span>
                              <Countries />
                            </div>
                            <div className="checkout-inps">
                              <span className="selectContry-hint">
                                Store Region / State
                              </span>
                              <input
                                type="text"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storeCountry: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="payment-month-cvc">
                            <label
                              htmlFor="store-city"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Store City
                              </span>
                              <input
                                type="text"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storeCity: e.target.value,
                                  })
                                }
                              />
                            </label>
                            <label
                              htmlFor="store-postcode"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Store Postcode
                              </span>
                              <input
                                type="text"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storePostcode: e.target.value,
                                  })
                                }
                              />
                            </label>
                          </div>
                          <label
                            htmlFor="store-shippolicy"
                            className="payment-input-field"
                          >
                            <span className="payment-inp-placeholder payment-inp-placeholder1">
                              Store Shipping Policy
                            </span>
                            <textarea
                              className="payment-input textarea-store"
                              defaultValue={""}
                              onChange={(e) =>
                                setValues({
                                  ...values,
                                  storeShipping: e.target.value,
                                })
                              }
                            />
                          </label>
                          <label
                            htmlFor="store-returnpolicy"
                            className="payment-input-field"
                          >
                            <span className="payment-inp-placeholder payment-inp-placeholder1">
                              Store Return Policy
                            </span>
                            <textarea
                              className="payment-input textarea-store"
                              defaultValue={""}
                              onChange={(e) =>
                                setValues({
                                  ...values,
                                  storeReturnPolicy: e.target.value,
                                })
                              }
                            />
                          </label>
                          <label
                            htmlFor="store-metakey"
                            className="payment-input-field"
                          >
                            <span className="payment-inp-placeholder payment-inp-placeholder1">
                              Store Meta Keywords
                            </span>
                            <textarea
                              className="payment-input payment-input1"
                              defaultValue={""}
                              onChange={(e) =>
                                setValues({
                                  ...values,
                                  storeAddress: e.target.value,
                                })
                              }
                            />
                          </label>
                          <label
                            htmlFor="store-metadesc"
                            className="payment-input-field"
                          >
                            <span className="payment-inp-placeholder payment-inp-placeholder1">
                              Store Meta Description
                            </span>
                            <textarea
                              className="payment-input textarea-store"
                              defaultValue={""}
                              onChange={(e) =>
                                setValues({
                                  ...values,
                                  storeMetaDescription: e.target.value,
                                })
                              }
                            />
                          </label>
                          <div className="payment-month-cvc">
                            <label
                              htmlFor="store-seourl"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                SEO URL For Store
                              </span>
                              <input
                                type="url"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storeSlug: e.target.value,
                                  })
                                }
                              />
                            </label>
                            <label
                              htmlFor="store-website"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Website Link
                              </span>
                              <input
                                type="url"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storeWebsite: e.target.value,
                                  })
                                }
                              />
                            </label>
                          </div>
                          <div className="payment-month-cvc">
                            <label
                              htmlFor="store-facebook"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Facebook Link
                              </span>
                              <input
                                type="url"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storeFacebook: e.target.value,
                                  })
                                }
                              />
                            </label>
                            <label
                              htmlFor="store-googleplus"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Google Plus Link
                              </span>
                              <input
                                type="url"
                                className="payment-input payment-input1"
                              />
                            </label>
                          </div>
                          <div className="payment-month-cvc">
                            <label
                              htmlFor="store-twitter"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Twitter Link
                              </span>
                              <input
                                type="url"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storeTwitter: e.target.value,
                                  })
                                }
                              />
                            </label>
                            <label
                              htmlFor="store-Insta"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Instagram Link
                              </span>
                              <input
                                type="url"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storeInstagram: e.target.value,
                                  })
                                }
                              />
                            </label>
                          </div>
                          <div className="payment-month-cvc">
                            <label
                              htmlFor="store-pinterest"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Pinterest Link
                              </span>
                              <input
                                type="url"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storePinterest: e.target.value,
                                  })
                                }
                              />
                            </label>
                            <label
                              htmlFor="store-whatsapp"
                              className="payment-input-field"
                            >
                              <span className="payment-inp-placeholder payment-inp-placeholder1">
                                Whatsapp Number
                              </span>
                              <input
                                type="text"
                                className="payment-input payment-input1"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    storeWhatsapp: e.target.value,
                                  })
                                }
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="fieldset-footer">
                        <div className="actions clearfix">
                          <ul role="menu" aria-label="Pagination">
                            <li aria-disabled="false">
                              <a
                                href="#previous"
                                style={{ display: "none" }}
                                role="menuitem"
                              >
                                Previous
                              </a>
                            </li>
                            <li aria-hidden="false" aria-disabled="false">
                              <a
                                href="#next"
                                role="menuitem"
                                onClick={profileVendor}
                              >
                                Next
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  _auth: state.auth,
});
profileVendor.PropTypes = {
  profileVendor: PropTypes.func.isRequired,
};

export default withRouter(
  connect(mapStateToProps, { profileVendor })(BecomeVendor)
);
